export default {
  TOP: 'Top',
  RIGHT: 'Right',
  BOTTOM: 'Bottom',
  LEFT: 'Left',
  UP: 'Up',
  DOWN: 'Down',
};
